import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/shared";
import { useNavigate, useParams } from "react-router-dom";
import { useWs } from "@/context/WorkspaceContext";
import { ArrowLeft, Calendar } from "lucide-react";

export default function ReportView() {
  const { channelId, reportId } = useParams();
  const { slug } = useWs();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get(`/reports/${reportId}`).then((r) => setReport(r.data));
  }, [reportId]);

  return (
    <div>
      <button data-testid="report-back-button" onClick={() => navigate(`/${slug}/reports/${channelId}`)} className="flex items-center gap-1.5 text-sm text-[#9FA1A4] hover:text-[#06060C] mb-6 transition-colors">
        <ArrowLeft className="h-4 w-4" /> Back to channel
      </button>

      {!report ? (
        <div className="text-[#9FA1A4] text-sm">Loading…</div>
      ) : (
        <div>
          <div className="mb-6">
            <h1 className="font-display text-3xl font-semibold tracking-tight">{report.name}</h1>
            {(report.date_start || report.date_end) && (
              <p className="mt-2 flex items-center gap-1.5 font-mono-data text-[11px] text-[#9FA1A4]">
                <Calendar className="h-3.5 w-3.5" /> {fmtDate(report.date_start)} – {fmtDate(report.date_end)}
              </p>
            )}
          </div>
          <div className="rounded-3xl border border-[#EEEFEF] premium-shadow bg-white p-6 md:p-8">
            <div data-testid="report-html-content" className="report-html" dangerouslySetInnerHTML={{ __html: report.html_content }} />
          </div>
        </div>
      )}
    </div>
  );
}
